module.exports = __webpack_public_path__ + "static/media/logo-text.3c2c3338.png";